/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EventLevelEnum } from './eventLevelEnum';


export interface EventConfigPatchSpec { 
    event_type: string;
    event_sub_type: string;
    level?: EventLevelEnum;
    tenant_ui?: boolean;
}
export namespace EventConfigPatchSpec {
}


